import LabelViewModelT from '@/ViewModels/Controls/LabelViewModel';
import CheckBoxViewModelT from '@/ViewModels/Controls/CheckBoxViewModel';
import ComponentManager from '@/Management/ComponentManager';

export default class CheckBoxViewModelBuilder {

    private label: LabelViewModelT;
    private enabledState: boolean | KnockoutObservable<boolean>;
    private isCheckedSubscription: (newValue: boolean) => void;
    private locator: string | KnockoutObservable<string> | KnockoutComputed<string>;

    public constructor() {

    }

    public withLocator(locator: string | KnockoutObservable<string> | KnockoutComputed<string>): CheckBoxViewModelBuilder {
        this.locator = locator;
        return this;
    }

    public withLabel(label: LabelViewModelT): CheckBoxViewModelBuilder {
        this.label = label;
        return this;
    }

    public withEnabledState(isEnabled: boolean | KnockoutObservable<boolean>): CheckBoxViewModelBuilder {
        this.enabledState = isEnabled;
        return this;
    }

    public withIsCheckedSubscription(callback: (newValue: boolean) => void): CheckBoxViewModelBuilder {
        this.isCheckedSubscription = callback;
        return this;
    }

    public create(): CheckBoxViewModelT {
        let CheckBoxViewModel = ComponentManager.getViewModel<typeof CheckBoxViewModelT>('CheckBoxViewModel');

        let box = new CheckBoxViewModel({
            label: this.label,
            isEnabled: this.enabledState,
            locator: this.locator
        });

        let subscription = box.isChecked.subscribe(isChecked => this.isCheckedSubscription(isChecked));

        if (_.isEmpty(box.subscriptionCollection)) {
            box.subscriptionCollection = [];
        }

        box.subscriptionCollection.push(subscription);

        return box;
    }
}